import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [organiser, setOrganiser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkSession = useCallback(async () => {
    try {
      const res = await api.get('/organiser/me', { withCredentials: true });
      setOrganiser(res.data.organiser);
    } catch {
      setOrganiser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkSession(); }, [checkSession]);

  const login = async (email, password) => {
    const res = await api.post('/organiser/login', { email, password }, { withCredentials: true });
    setOrganiser(res.data.organiser);
    return res.data;
  };

  const logout = async () => {
    try {
      await api.post('/organiser/logout', {}, { withCredentials: true });
    } catch {}
    setOrganiser(null);
  };

  const refreshMe = async () => {
    try {
      const res = await api.get('/organiser/me', { withCredentials: true });
      setOrganiser(res.data.organiser);
    } catch {
      setOrganiser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ organiser, loading, login, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
